// Utilidades de presentación de emergencias médicas (sin estado ni Angular).
//
// El nombre del archivo se conserva porque el tablero importa
// `colorPrioridadNegro` desde acá. La paleta de estados, prioridades y
// situaciones vive en `../estado-emergencia.ts`.
import { IDestinatarioAsistencia, IEmergencia } from 'modelos/src';

/** Código "Negro" en gráficos: el negro puro desaparece sobre el fondo oscuro. */
export const colorPrioridadNegro = (): string =>
  document.body.classList.contains('dark-theme') ? '#757575' : 'black';

/** "23/09/2026 16:42", siempre en 24 horas. Vacío si no hay fecha. */
export function fechaHoraEmergencia(
  fecha: string | Date | undefined | null,
): string {
  if (!fecha) return '';
  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n: number) => String(n).padStart(2, '0');
  return (
    `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ` +
    `${p(d.getHours())}:${p(d.getMinutes())}`
  );
}

/** "1 h 5 min", "12 min", "40 s". */
export function formatDuracion(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) ms = 0;
  const tot = Math.floor(ms / 1000);
  const d = Math.floor(tot / 86400);
  const h = Math.floor((tot % 86400) / 3600);
  const m = Math.floor((tot % 3600) / 60);
  const s = tot % 60;
  if (d > 0) return h ? `${d} d ${h} h` : `${d} d`;
  if (h > 0) return m ? `${h} h ${m} min` : `${h} h`;
  if (m > 0) return `${m} min`;
  return `${s} s`;
}

/** Duración entre dos fechas, o `null` si falta alguna. */
export function calcDiff(
  f1?: string | null,
  f2?: string | null,
): string | null {
  if (!f1 || !f2) return null;
  const a = new Date(f1).getTime();
  const b = new Date(f2).getTime();
  if (Number.isNaN(a) || Number.isNaN(b)) return null;
  return formatDuracion(b - a);
}

/** "hace 5 min", "recién". */
export function haceCuanto(fecha: string | Date | undefined | null): string {
  if (!fecha) return '';
  const ms = new Date(fecha).getTime();
  if (Number.isNaN(ms)) return '';
  const seg = Math.floor((Date.now() - ms) / 1000);
  if (seg < 60) return 'recién';
  return `hace ${formatDuracion(seg * 1000)}`;
}

/** "Pérez, Juan" o "" si no hay paciente. */
export function nombrePaciente(p?: IDestinatarioAsistencia | null): string {
  if (!p) return '';
  return [p.apellido, p.nombre].filter(Boolean).join(', ');
}

/** Prioridad vigente: la de cierre si la hay, si no la de apertura. */
export function prioridadVigente(e?: IEmergencia | null): string | undefined {
  return e?.prioridadCierre || e?.prioridadApertura;
}
